import { TimelineSeparator } from "@mui/lab";
import Box from "@mui/material/Box";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

import { NyuTheme } from "../../../layout/NyuTheme";
import { Time } from "./Time";
import { TimelineEventDot } from "./TimelineEventDot";
import { useScreenWidth } from "../../../media";

type TimelineEntryProps = {
	name: string;
	isEta?: boolean;
	latest?: boolean;
	time: Date;
	comments?: string | null;
	actions?: React.ReactNode;
};

export const TimelineEntry = ({
	name,
	isEta = false,
	latest = false,
	time,
	comments,
	actions,
}: TimelineEntryProps) => {
	const greaterThanSm = useScreenWidth("sm");

	return (
		<TableRow sx={{ verticalAlign: "top" }}>
			<TableCell sx={{ border: 0 }}>
				<TimelineSeparator>
					<TimelineEventDot isEta={isEta} latest={latest} />
				</TimelineSeparator>
			</TableCell>

			<TableCell>
				<Time time={time} isEta={isEta} />
			</TableCell>
			<TableCell>
				<Box
					sx={{
						display: "flex",
						overflowWrap: {
							xs: "anywhere",
							mobile: "normal",
						},
					}}
				>
					{name}
					{!greaterThanSm && (
						<Box sx={{ order: 2, marginLeft: "auto" }}>{actions}</Box>
					)}
				</Box>

				{comments && (
					<Typography
						variant="caption"
						sx={{
							color: NyuTheme.palette.caption.main,
							whiteSpace: "pre-line",
							lineHeight: "18px",
							overflowWrap: "anywhere",
						}}
					>
						{comments}
					</Typography>
				)}
			</TableCell>
			{greaterThanSm && actions && <TableCell>{actions}</TableCell>}
		</TableRow>
	);
};
